var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href:
            "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
        }
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline m-0" },
            [
              _c(
                "h3",
                [
                  _c("v-icon", [_vm._v("today")]),
                  _vm._v("Procesamiento de control de asistencia")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer")
            ],
            1
          ),
          _vm._v(" "),
          _c("v-card", [_c("MonitoreoTipificacion")], 1),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "p-0" },
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "p-0",
                          staticStyle: { "min-width": "100%" },
                          attrs: { "grid-list-md": "" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha inicio",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_inicio,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_inicio", $$v)
                                      },
                                      expression: "form.fecha_inicio"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha fin",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_fin,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_fin", $$v)
                                      },
                                      expression: "form.fecha_fin"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      items: _vm.unidades_especificas,
                                      "item-value": "id_unidad",
                                      "item-text": "nombre_unidad",
                                      label: "Unidad especifica",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.id_unidad_especifica,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_unidad_especifica",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_unidad_especifica"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Paterno",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.paterno,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "paterno", $$v)
                                      },
                                      expression: "form.paterno"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Materno",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.materno,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "materno", $$v)
                                      },
                                      expression: "form.materno"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Nombres",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.nombres,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "nombres", $$v)
                                      },
                                      expression: "form.nombres"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Cédula de identidad",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.ci,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "ci", $$v)
                                      },
                                      expression: "form.ci"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Item",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.item,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "item", $$v)
                                      },
                                      expression: "form.item"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { staticClass: "layout", attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        disabled: !_vm.bandera_boton_buscar,
                                        color: "rgba(31,14,180,0.3)",
                                        type: "submit"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.filtraFuncionarios()
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("search")]),
                                      _vm._v(
                                        "\n                  Buscar\n                "
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "rgba(158,11,127,0.6)",
                                        type: "submit"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.limpiarCampos()
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("redo")]),
                                      _vm._v(
                                        "\n                  Limpiar\n                "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "py-0 m-0",
                                  attrs: { xs12: "", md6: "" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mx-0 my-1",
                                      attrs: {
                                        color: "rgb(64,79,191)",
                                        block: "",
                                        loading: _vm.loading,
                                        disabled:
                                          !_vm.form.fecha_inicio ||
                                          !_vm.form.fecha_fin ||
                                          (!_vm.form.fecha_inicio &&
                                            !_vm.form.fecha_fin),
                                        dark: "",
                                        title: "Procesar ASP-B"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.tipificar()
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("schedule")]),
                                      _vm._v(
                                        "\n                  PROCESAR ASP-B\n                "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "py-0 m-0",
                                  attrs: { xs12: "", md6: "" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mx-0 my-1",
                                      attrs: {
                                        color: "rgb(80,38,217)",
                                        block: "",
                                        loading: _vm.loading_unidad,
                                        title: "Procesar por unidad",
                                        dark: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.tipificarPorUnidad()
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("schedule")]),
                                      _vm._v(
                                        "\n                  PROCESAR POR UNIDAD\n                "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "pt-0 pb-3 m-0",
                                  attrs: { xs12: "" }
                                },
                                [_c("NotificacionFaltas")],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.lista_filtrada_funcionarios,
                  "no-data-text": _vm.loading
                    ? "Cargando..."
                    : "No se tiene registros",
                  loading: _vm.loading,
                  "item-key": "index",
                  "rows-per-page-text": "Filas por pagina",
                  pagination: _vm.pagination,
                  "rows-per-page-items": [
                    5,
                    10,
                    20,
                    50,
                    { value: -1, text: "Todos" }
                  ]
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "headers",
                    fn: function(props) {
                      return [
                        _c(
                          "tr",
                          _vm._l(props.headers, function(header) {
                            return _c(
                              "th",
                              {
                                key: header.text,
                                staticClass: "header-comprmido",
                                class: [
                                  "column sortable",
                                  _vm.pagination.descending ? "desc" : "asc",
                                  header.value === _vm.pagination.sortBy
                                    ? "active"
                                    : ""
                                ],
                                attrs: { id: "cabecera_tabla" },
                                on: {
                                  click: function($event) {
                                    return _vm.changeSort(header.value)
                                  }
                                }
                              },
                              [
                                header.value
                                  ? _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "white" } },
                                      [_vm._v("arrow_upward")]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(header.text) +
                                    "\n            "
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]
                    }
                  },
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c(
                          "td",
                          { staticClass: "text-xs-center py-0 px-1" },
                          [
                            _c(
                              "v-avatar",
                              {
                                attrs: {
                                  color: props.item.foto
                                    ? "#FFF"
                                    : "light-blue darken-4"
                                }
                              },
                              [
                                props.item.foto
                                  ? _c("img", {
                                      staticStyle: {
                                        border: "1px solid #7BAFD4 !important"
                                      },
                                      attrs: {
                                        src: _vm.url_backend + props.item.foto,
                                        alt: props.item.nombres[0]
                                      },
                                      on: {
                                        error: function($event) {
                                          return _vm.handleImageError(
                                            props.item
                                          )
                                        }
                                      }
                                    })
                                  : _c(
                                      "span",
                                      { staticClass: "white--text headline" },
                                      [
                                        _vm._v(
                                          _vm._s(props.item.nombres[0] || "-")
                                        )
                                      ]
                                    )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nro_item) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.ap_paterno) +
                              " " +
                              _vm._s(props.item.ap_materno) +
                              "\n            " +
                              _vm._s(props.item.nombres) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nro_doc) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.dependencia) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nombre_unidad) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "#F58736",
                                  outline: "",
                                  icon: "",
                                  title: "Tpificar",
                                  loading: props.item.loading == true
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.tipificarPorPersona(props.item)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("schedule")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "blue",
                                  outline: "",
                                  icon: "",
                                  title: "Ajustar procesamiento",
                                  to:
                                    "/ajuste-tipificacion/" +
                                    props.item.id_persona
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "material-symbols-outlined" },
                                  [
                                    _vm._v(
                                      "\n                build\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71fd22a3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71fd22a3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asistencia/AsistenciaTipificacion.vue
// module id = null
// module chunks = 